// export const ICON_MAP = {
//   anxiety: <YourAnxietyIcon />,
//   depression: <YourDepressionIcon />,
//   adhd: <YourADHDIcon />,
//   trauma: <YourTraumaIcon />,
//   burnout: <YourBurnoutIcon />,
//   stress: <YourStressIcon />,
//   work_stress: <YourWorkIcon />,
//   sleep: <YourSleepIcon />,
//   focus: <YourFocusIcon />,
//   panic: <YourPanicIcon />,
//   not_sure: <YourNotSureIcon />,
// };

import { STATE_CONCERN_OPTIONS } from "./carejourney";

export const NewPatientIcon = ({ size = 52 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--primary-color)"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
    <line x1="19" y1="8" x2="19" y2="14" />
    <line x1="16" y1="11" x2="22" y2="11" />
  </svg>
);

export const ExistingPatientIcon = ({ size = 52 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--primary-color)"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
    <polyline points="16 11 18 13 22 9" />
  </svg>
);

export const ICON_MAP_MENTAL = {
  anxiety: (
    <svg className="w-7 h-7 text-purple-500" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23-.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0112 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" />
      </svg>
  ),

  depression: (
    <svg className="w-7 h-7 text-blue-400" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z" />
      </svg>
  ),

 stress: (
    <svg className="w-7 h-7 text-orange-400" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h10M4 18h7" />
    </svg>
  ),

  burnout: (
    <svg className="w-7 h-7 text-amber-500" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
      </svg>
  ),

  sleep: (
    <svg className="w-7 h-7 text-indigo-400" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 3a9 9 0 009 9 9 9 0 11-9-9z" />
    </svg>
  ),

  work_stress: (
    <svg className="w-7 h-7 text-gray-500" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 7V5h12v2M3 7h18v12H3V7z" />
    </svg>
  ),

  adhd: (
    <svg className="w-7 h-7 text-orange-400" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003 2.48z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 18a3.75 3.75 0 00.495-7.467 5.99 5.99 0 00-1.925 3.546 5.974 5.974 0 01-2.133-1A3.75 3.75 0 0012 18z" />
      </svg>
  ),

  focus: (
    <svg className="w-7 h-7 text-teal-500" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="3" />
      <circle cx="12" cy="12" r="8" />
    </svg>
  ),

  panic: (
    <svg className="w-7 h-7 text-red-400" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01M12 2a10 10 0 100 20 10 10 0 000-20z" />
    </svg>
  ),

  overthinking: (
    <svg className="w-7 h-7 text-violet-400" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6l4 2M12 2a10 10 0 100 20 10 10 0 000-20z" />
    </svg>
  ),

  fatigue: (
    <svg className="w-7 h-7 text-yellow-500" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="9" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6l3 2" />
    </svg>
  ),

  lonely: (
    <svg className="w-7 h-7 text-gray-400" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <circle cx="12" cy="8" r="3" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 20c0-3.5 3-6 7-6s7 2.5 7 6" />
    </svg>
  ),

  family_stress: (
    <svg className="w-7 h-7 text-green-500" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l9-7 9 7M5 10v10h14V10" />
    </svg>
  ),

  career_stress: (
    <svg className="w-7 h-7 text-blue-500" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-6h6v6M4 21h16" />
    </svg>
  ),

  anger: (
    <svg className="w-7 h-7 text-red-500" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v10m0 4h.01M4 20h16" />
    </svg>
  ),

  addiction: (
    <svg className="w-7 h-7 text-purple-600" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 14a4 4 0 005.656 0l2.828-2.828a4 4 0 00-5.656-5.656L11 7" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M14 10a4 4 0 00-5.656 0L5.515 12.828a4 4 0 005.656 5.656L13 17" />
    </svg>
  ),

  trauma: (
      <svg className="w-7 h-7 text-emerald-500" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
      </svg>
  ),

  not_sure: (
    <svg className="w-7 h-7 text-gray-400" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
      </svg>
  ),
};


export const ICON_MAP = {
  period_disorders: (
    <svg className="w-7 h-7 text-pink-500" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="8" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l2 2" />
    </svg>
  ),

  pcos_hormonal: (
    <svg className="w-7 h-7 text-purple-500" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v4m0 10v4m8-8h-4M8 12H4" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),

  fibroids: (
    <svg className="w-7 h-7 text-orange-400" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="6" />
      <circle cx="9" cy="10" r="1.5" />
      <circle cx="14" cy="13" r="1.5" />
    </svg>
  ),

  endometriosis: (
    <svg className="w-7 h-7 text-emerald-500" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 3l7 4v5c0 5-3.5 8-7 9-3.5-1-7-4-7-9V7l7-4z" />
    </svg>
  ),

  pelvic_pain: (
    <svg className="w-7 h-7 text-amber-500" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6m0 4h.01M4 20h16" />
    </svg>
  ),

  fertility_issues: (
    <svg className="w-7 h-7 text-rose-400" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 21s-6-4.35-9-8a5.5 5.5 0 019-7 5.5 5.5 0 019 7c-3 3.65-9 8-9 8z" />
    </svg>
  ),

  pregnancy_care: (
    <svg className="w-7 h-7 text-teal-500" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <circle cx="12" cy="10" r="3" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 20c0-4 3-6 6-6s6 2 6 6" />
    </svg>
  ),

  menopause: (
    <svg className="w-7 h-7 text-red-400" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v18M5 12h14" />
    </svg>
  ),

  vaginal_health: (
    <svg className="w-7 h-7 text-indigo-400" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <ellipse cx="12" cy="12" rx="6" ry="8" />
    </svg>
  ),

  hormonal_imbalance: (
    <svg className="w-7 h-7 text-violet-500" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 12h16M12 4v16" />
    </svg>
  ),

  not_sure: (
    <svg className="w-7 h-7 text-gray-400" fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.879 7.519a3 3 0 114.242 4.242c-.5.5-1.121.8-1.621 1.3V15M12 18h.01" />
      <circle cx="12" cy="12" r="9" />
    </svg>
  ),
};


export const getDynamicConcerns = (state) => {
  const base = STATE_CONCERN_OPTIONS[state] || STATE_CONCERN_OPTIONS["default"];

  return base.map(item => ({
    ...item,
    icon: ICON_MAP[item.value],
  }));
};